export default {
  'table.status': 'Status',
  'table.name': 'Name',
  'table.email': 'Email',
  'table.nameWithParams': '{ value } Name',
  'table.description': 'Description',
  'table.actions': 'Actions',
  'table.userId': 'User ID',
  'table.button.viewFullProfile': 'View Full Profile'
};
